import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";

const RCPhoneCountrySelect = ({
  value,
  onChange,
  options = [],
  disabled,
  readOnly,
  iconComponent: Icon,
  onFocus,
  onBlur,
  "aria-label": ariaLabel,
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const isDisabled = disabled || readOnly;

  const selectedOption = options.find(
    (option) => !option.divider && option.value === value
  );

  useEffect(() => {
    if (!open) return undefined;

    const handleOutsideClick = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
        onBlur?.();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [open, onBlur]);

  const handleToggle = () => {
    if (isDisabled) return;

    if (!open) {
      onFocus?.();
      setOpen(true);
      return;
    }

    setOpen(false);
    onBlur?.();
  };

  const handleSelect = (countryValue) => {
    onChange(countryValue === "ZZ" ? undefined : countryValue);
    setOpen(false);
    onBlur?.();
  };

  return (
    <div
      ref={rootRef}
      className={classNames("PhoneInputCountry rc-phone-country", {
        "rc-phone-country--open": open,
        "rc-phone-country--disabled": isDisabled,
      })}
    >
      <button
        type="button"
        className="rc-phone-country__trigger"
        disabled={isDisabled}
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-haspopup="listbox"
        onClick={handleToggle}
      >
        {Icon && value ? (
          <Icon
            country={value}
            label={selectedOption?.label}
            aria-hidden
          />
        ) : null}
        <span className="PhoneInputCountrySelectArrow" aria-hidden />
      </button>

      {open && (
        <ul className="rc-phone-country__menu" role="listbox">
          {options
            .filter((option) => !option.divider)
            .map((option) => (
              <li
                key={option.value || "ZZ"}
                role="option"
                aria-selected={option.value === value}
                className={classNames("rc-phone-country__option", {
                  "rc-phone-country__option--selected": option.value === value,
                })}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default RCPhoneCountrySelect;
